@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.border-line {
  height: 1px;
  background: @settings-page--integration--border-color; //this is treated as a border
  margin: 16px 0;
}

.webhook-button {
  display: flex;
  justify-content: center;
}

.existing-webhooks-line1 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-bottom: 8px;

  .buttons {
    margin-right: 16px;

    .edit-button {
      margin-right: 8px;
    }

    .delete-webhook {
      height: 32px;
      padding: 0 10px;
    }
  }
}

.existing-webhooks-line2 {
  display: grid;
  grid-template-columns: 1fr;
}

.popup-box {
  width: 170px;
  height: 75px;
  text-align: center;

  > div {
    font-size: 14px;
    margin: 12px 8px;
  }

  > button {
    background-color: @settings-page--integration--error--background-color;
    color: @settings-page--integration--error--text-color;
    font-weight: 400;

    &:hover {
      background-color: @settings-page--integration--error--hover--background-color;
    }
  }
}

.webhook-form-row1 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 14px;
  margin-bottom: 8px;

  .webhook-input {
    > button {
      margin: 0;
      width: 100%;
    }
  }
}

.webhook-form-row2 {
  display: grid;
  grid-template-columns: 1fr auto auto;
  grid-gap: 14px;

  .webhook-cancel-button {
    margin-right: 14px;
    margin-left: -6px;
  }
}
